import styled from 'styled-components';
import { Image, Box, Flex, Grid } from '../../atoms';
export const Container = styled(Grid).attrs(containerProps => Object.assign({
  display: 'flex',
  px: 3,
  py: '10px',
  backgroundColor: 'background.lighter',
  border: '1px solid #B8C1C4',
  borderRadius: '8px'
}, containerProps))`
  width: 100%;
  gap: 14px;
  grid-template-columns: minmax(auto, 42px) auto;
  grid-template-areas: 'f c';
`;
export const InfoContainer = styled(Flex)`
  flex-direction: column;
  justify-content: space-around;
  grid-area: c;
`;
export const FigureContainer = styled(Box).attrs(props => Object.assign({
  mr: 2,
  height: '32px'
}, props))`
  grid-area: f;
`;
export const BrandFigure = styled(Image)``;
export const InfoText = styled(Box).attrs(props => Object.assign({
  forwardedAs: 'p',
  color: 'text.base',
  fontWeight: '500',
  fontSize: '14px',
  lineHeight: '16px'
}, props))``;